/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValueWithNote } from './ValueWithNote';
import {
    ValueWithNoteFromJSON,
    ValueWithNoteFromJSONTyped,
    ValueWithNoteToJSON,
    ValueWithNoteToJSONTyped,
} from './ValueWithNote';

/**
 * 
 * @export
 * @interface StructuredAnalysisResponseDataCoverageStatus
 */
export interface StructuredAnalysisResponseDataCoverageStatus {
    /**
     * 
     */
    facility_status?: ValueWithNote;
    /**
     * 
     */
    payer?: ValueWithNote;
    /**
     * 
     */
    plan_type?: ValueWithNote;
    /**
     * 
     */
    benefit_period?: ValueWithNote;
    /**
     * 
     */
    previous_stay_in_current_benefit_period?: ValueWithNote;
    /**
     * 
     */
    most_recent_snf_stay?: ValueWithNote;
    /**
     * 
     */
    npi_of_previous_stay_facility?: ValueWithNote;
}

/**
 * Check if a given object implements the StructuredAnalysisResponseDataCoverageStatus interface.
 */
export function instanceOfStructuredAnalysisResponseDataCoverageStatus(value: object): value is StructuredAnalysisResponseDataCoverageStatus {
    return true;
}

export function StructuredAnalysisResponseDataCoverageStatusFromJSON(json: any): StructuredAnalysisResponseDataCoverageStatus {
    return StructuredAnalysisResponseDataCoverageStatusFromJSONTyped(json, false);
}

export function StructuredAnalysisResponseDataCoverageStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredAnalysisResponseDataCoverageStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_status': json['facility_status'] == null ? undefined : ValueWithNoteFromJSON(json['facility_status']),
        'payer': json['payer'] == null ? undefined : ValueWithNoteFromJSON(json['payer']),
        'plan_type': json['plan_type'] == null ? undefined : ValueWithNoteFromJSON(json['plan_type']),
        'benefit_period': json['benefit_period'] == null ? undefined : ValueWithNoteFromJSON(json['benefit_period']),
        'previous_stay_in_current_benefit_period': json['previous_stay_in_current_benefit_period'] == null ? undefined : ValueWithNoteFromJSON(json['previous_stay_in_current_benefit_period']),
        'most_recent_snf_stay': json['most_recent_snf_stay'] == null ? undefined : ValueWithNoteFromJSON(json['most_recent_snf_stay']),
        'npi_of_previous_stay_facility': json['npi_of_previous_stay_facility'] == null ? undefined : ValueWithNoteFromJSON(json['npi_of_previous_stay_facility']),
    };
}

export function StructuredAnalysisResponseDataCoverageStatusToJSON(json: any): StructuredAnalysisResponseDataCoverageStatus {
    return StructuredAnalysisResponseDataCoverageStatusToJSONTyped(json, false);
}

export function StructuredAnalysisResponseDataCoverageStatusToJSONTyped(value?: StructuredAnalysisResponseDataCoverageStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_status': ValueWithNoteToJSON(value['facility_status']),
        'payer': ValueWithNoteToJSON(value['payer']),
        'plan_type': ValueWithNoteToJSON(value['plan_type']),
        'benefit_period': ValueWithNoteToJSON(value['benefit_period']),
        'previous_stay_in_current_benefit_period': ValueWithNoteToJSON(value['previous_stay_in_current_benefit_period']),
        'most_recent_snf_stay': ValueWithNoteToJSON(value['most_recent_snf_stay']),
        'npi_of_previous_stay_facility': ValueWithNoteToJSON(value['npi_of_previous_stay_facility']),
    };
}

